import { render, staticRenderFns } from "./TruncateOrder.vue?vue&type=template&id=7a9fd304&"
import script from "./TruncateOrder.vue?vue&type=script&lang=js&"
export * from "./TruncateOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports